import { all, takeEvery, takeLatest, put, fork } from "redux-saga/effects";

//import axios from "axios";
import axios from "./initialize";

import { Modal } from "antd";
import {
  ExclamationCircleOutlined,
  CheckCircleFilled,
  WarningFilled
} from "@ant-design/icons";
import {
  SAVE_APP,
  DELETE_APP,
  GET_APP_LIST,
  PUBLISH_APP,
  EDIT_APP,
  GET_PUBLISHED_APP_LIST,
  SUBSCRIBE_APP,
  GET_SUBSCRIBED_APP_LIST,
  GET_MENU_APP_LIST,
  GET_DEVELOPER_APP,
  GET_MFA_SETUP_HOME,
  APP_LOGIN_AUTHENTICATION,
  USING_2FA,
  GET_USING_2FA_VALUE,
  ADD_APP_PERMISSION,
  ADD_APP_ROLE,
  GET_APP_PERMISSIONS,
  GET_APP_ROLES,
  DELETE_APP_PERMISSION,
  UPDATE_APP_PERMISSION,
  DELETE_APP_ROLE,
  UPDATE_APP_ROLE,
  GET_APP_ROLE_PERMISSIONS,
  ADD_APP_SETTINGS_JSON,
  GET_APP_SETTINGS_DETAILS,
  GET_APP_INSTANCE_DATA,
  UI_PROPERTIES_JSON,
  APP_UI_PROPERTIES,
  ADD_APP_UI_PROPERTIES,
  EDIT_APP_UI_PROPERTIES,
  DELETE_APP_UI_PROPERTIES,
  GET_ADMIN_APP_UI_PROPERTIES,
  SUBSCRIBE_APP_DETAIL_PAGE,
  SUBSCRIBE_APP_SETTINGS_PAGE,
  GET_ACCOUNT_USER_APP_INSTANCE_ROLES,
  APP_UI_PROPERTY,
  DELETE_APP_UI_PROPERTY,
  EDIT_APP_UI_PROPERTY,
  ADD_APP_UI_PROPERTY
} from "redux/constants/app";

import {
  apps,
  app,
  showAppMessage,
  registerSuccess,
  publishedAppList,
  subscribedAppList,
  menuAppList,
  developerApp,
  twoFactorPageSuccess,
  toggle2fa,
  appPermissions,
  appRoles,
  appRolePermissions,
  setAddEdit,
  appSettingsJson,
  appData,
  uiPropertiesJson,
  accountUserAppInstanceRoles
} from "redux/actions/app";
import { API_BASE_DEVELOPER_APP, API_BASE_URL, APP_PREFIX_PATH, AUTH_PREFIX_PATH, MANAGE_PREPIX_PATH, USERS_PREPIX_PATH,API,VERSION } from "configs/AppConfig";
import { AUTH_TOKEN } from "../constants/Auth";
import { t } from "i18next";
import { PATH_VARIABLE } from "constants/ApiConstant";
import { appInstaneData } from "redux/actions/appInstance";
import trace from "auth/trace";
import { v4 as uuidv4 } from "uuid";
import { tabRefs } from "utils/tabManager";

const DEFAULT_APPS_SORT_FIELD = "name";
const DEFAULT_APPS_SORT_ORDER = "ascend";

const normalizeAppsSortOrder = (order) => {
  if (!order) {
    return DEFAULT_APPS_SORT_ORDER;
  }

  const normalized = String(order).toLowerCase();
  if (normalized === "ascend" || normalized === "asc") {
    return "ascend";
  }
  if (normalized === "descend" || normalized === "desc") {
    return "descend";
  }

  return DEFAULT_APPS_SORT_ORDER;
};

const resolveAppsSortParams = (sorter) => ({
  sortField: sorter?.field || DEFAULT_APPS_SORT_FIELD,
  sortOrder: normalizeAppsSortOrder(sorter?.order),
});

export function* getApps() {
  yield takeLatest(GET_APP_LIST, function* ({ requestData }) {
    const userId = localStorage.getItem("id");
    const accountId = requestData?.accountId || localStorage.getItem("accountId");
    const parentAppId =
      requestData?.parentAppId || localStorage.getItem("parentAppId");
    const query = requestData?.query ?? "";
    const { sortField, sortOrder } = resolveAppsSortParams(requestData?.sorter);
    const page = (requestData?.pagination?.current ?? 1) - 1;
    const pageSize = requestData?.pagination?.pageSize ?? 10;
    const listType = requestData?.type || "app";
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId,
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const appResponse = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/apps?accountId=${accountId}&parentAppId=${parentAppId}&query=${query}&sortfield=${sortField}&sortorder=${sortOrder}&page=${page}&size=${pageSize}&type=${listType}`,
        config
      );
      if (appResponse.status === 200) {
        const responseData = appResponse.data || {};
        const developerAppName = `DeveloperApp_${accountId}`;
        const content = Array.isArray(responseData.content)
          ? responseData.content.filter(
              (item) => item?.name !== developerAppName
            )
          : [];
        const filteredAppsData = {
          ...responseData,
          content,
        };
        if(query!==undefined && query!==""){
					const traceObj ={
						type: `search_get_${requestData?.type}s`,
						event: 'click',
						message: `${appResponse?.data?.totalElements-1} results found for accountId=${accountId} and Keyword=${requestData?.query}`,
            status: `${requestData?.type}s retrieve successfully `,
						action: `Search get ${requestData?.type}s`,
						referer_action_id: localStorage.getItem("referer_action_id"),
						trackId: uuidv4(),
						user_session: sessionStorage.getItem("user_session")
					  };
					  localStorage.setItem("referer_action_id",traceObj.trackId);
					  trace({"traceObj":traceObj});
					}else{
            const traceObj ={
							type: `get_${requestData?.type}s`,
							event: 'click',
							message: `${appResponse?.data?.totalElements-1} results found for accountId=${accountId}`,
							status: `${requestData?.type}s retrieve successfully `,
							action: `clicked get ${requestData?.type}s`,
							referer_action_id: localStorage.getItem("referer_action_id"),
							trackId: uuidv4(),
							user_session: sessionStorage.getItem("user_session")
						};
						localStorage.setItem("referer_action_id",traceObj.trackId);
						trace({"traceObj":traceObj});
				}

					
        yield put(apps(filteredAppsData, requestData?.type));
      }
    } catch (err) {
      if(query!==undefined && query!==""){
        const traceObj ={
          type: `search_get_${requestData?.type}s`,
          event: 'click',
          message: `0 results found for keyword=${requestData?.query} and accountId=${accountId}`,
          status: `Failed to retrieve ${requestData?.type}s`,
          action: `Search tp get ${requestData?.type}s`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }else{
          const traceObj ={
            type: `get_${requestData?.type}s`,
            event: 'click',
            message: `0 results found for accountId=${accountId}`,
            status: `Failed to retrieve ${requestData?.type}s`,
            action: `clicked get ${requestData?.type}s`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
      }
      console.log(err);
      yield put(showAppMessage(err?.response));
    }
  });
}

export function* publishApp() {
  yield takeEvery(PUBLISH_APP, function* ({ payload }) {
    const {app,stop,publish,edit}=payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/app/${app?.id}`,
        app,
        config
      );
      if (res.status === 200) {
        const type=`${publish?`${app?.published}_${app?.type}`:edit==="edit"?`update_${app?.type}`:"stop_new_subscription"}`;
        const message=`${publish?`${app?.published} ${app?.type} for id=${app?.id}`:`${edit==="edit"?`${app?.type} updated for appId=${app?.id}`:stop?`stop new subscription enabled for appId=${app?.id}`:`stop new subscription disabled for appId=${app?.id}`}`}`;
        const status=`${publish?`${app?.type} ${app?.published} successfully `:`${edit==="edit"?`${app?.type} updated successfully`:stop?"stop new subscription enabled successfully":"stop new subscription disabled successfully"}`}`;
        const action=`${publish?`clicked ${app?.published} ${app?.type}`:edit==="edit"?`clicked ${app?.type} update`:"clicked stop new subscription"}`;
        const traceObj ={
            type: `${type}`,
            event: 'click',
            message: `${message}`,
            status: `${status}`,
            action: `${action}`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
        var title = t("impaqx.adminApp.appUpdateMessage")?.replace("updated",publish?app?.published?.toString()
        .toLowerCase():edit==="edit"?"updated":stop?"stop new subscription enabled":"stop new subscription disabled").replace("App",app?.type?.toString()
        .toLowerCase());
        Modal.success({
          title: title?.charAt(0).toUpperCase() + title?.slice(1),
          icon: <CheckCircleFilled />,
          okText:t("impaqx.adminApp.close"),
          //cancelText: 'Cancel',
          onOk() {
            //deleteApp(id);
          },
        });
        yield put(showAppMessage(res));
      }
    } catch (error) {
      const type=`${publish?`${app?.published}_${app?.type}`:edit==="edit"?`update_${app?.type}`:"stop_new_subscription"}`;
        const message=`${publish?`Failed to ${app?.published} ${app?.type} for id=${app?.id}`:`${edit==="edit"?`Failed to ${app?.type} updated for appId=${app?.id}`:stop?`Failed to stop new subscription enabled for appId=${app?.id}`:`Failed to stop new subscription disabled for appId=${app?.id}`}`}`;
        const status=`${publish?`Failed to ${app?.type} ${app?.published}`:`${edit==="edit"?`Failed to ${app?.type} updated`:stop?"Failed to stop new subscription enabled":"Failed to stop new subscription disabled"}`}`;
        const action=`${publish?`clicked ${app?.published} ${app?.type}`:edit==="edit"?`clicked ${app?.type} update`:"clicked stop new subscription"}`;
      const traceObj ={
        type: `${type}`,
        event: 'click',
        message: `${message}`,
        status: `${status}`,
        action: `${action}`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
        }; 
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* getPublishedApps() {
  yield takeLatest(GET_PUBLISHED_APP_LIST, function* ({ payload }) {
    const accountId = localStorage.getItem("accountId");
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/publishedApps?accountId=${accountId}&published=${payload.published}&type=${payload.type}`,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `get_published_${payload?.type}s`,
          event: 'click',
          message: `${res?.data?.totalElements} results found for accountId=${accountId}`,
          status: `Get published ${payload?.type}s successfully `,
          action: `Clicked published ${payload?.type}s`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        yield put(publishedAppList(res.data));
      }
    } catch (error) {
      const traceObj ={
        type: `get_published_${payload?.type}s`,
        event: 'click',
        message: `0 results found for accountId=${accountId}`,
        status: `Failed to get published ${payload?.type}s`,
        action: `clicked published ${payload?.type}s`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* getSubscribedApps() {
  yield takeLatest(GET_SUBSCRIBED_APP_LIST, function* ({ requestData }) {
    const {query,published } = requestData ;
    const accountId = localStorage.getItem("accountId");
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/subscribedApps?accountId=${accountId}&query=${requestData?.query}&type=${requestData?.type}`,
        config
      );
      if (res.status === 200) {
        // if(query!==undefined && query!==""){
				// 	const traceObj ={
				// 			type: `subscribed_apps_search`,
				// 			event: 'click',
				// 			message: `${res?.data?.totalElements} results found for accountId=${accountId} and keyword=${requestData?.query}`,
				// 			status: ` Get Subscribed Apps successfully  `,
				// 			action: `Search subscribed apps`,
				// 			referer_action_id: localStorage.getItem("referer_action_id"),
				// 			trackId: uuidv4(),
				// 			user_session: sessionStorage.getItem("user_session")
				// 		};
				// 		localStorage.setItem("referer_action_id",traceObj.trackId);
				// 		trace({"traceObj":traceObj});
				// 	}else{
          if(published!=='PUBLISHED'){
					  const traceObj ={
							type: `get_subscribed_${requestData?.type}s`,
							event: 'click',
							message: `${res?.data?.totalElements} results found for accountId=${accountId} `,
							status: ` Get subscribed ${requestData?.type}s successfully  `,
							action: `Clicked subscribed ${requestData?.type}s`,
							referer_action_id: localStorage.getItem("referer_action_id"),
							trackId: uuidv4(),
							user_session: sessionStorage.getItem("user_session")
						  }; 
						  localStorage.setItem("referer_action_id",traceObj.trackId);
						  trace({"traceObj":traceObj});
            }
            // }
        yield put(subscribedAppList(res.data));
      }
    } catch (error) {
      // if(query!==undefined && query!==""){
      //   const traceObj ={
      //       type: `subscribed_apps_search`,
      //       event: 'click',
      //       message: `0 results found for accountId=${accountId} and keyword=${requestData?.query}`,
      //       status: `Failed to get subscribed apps`,
      //       action: `Clicked to get subscribed apps`,
      //       referer_action_id: localStorage.getItem("referer_action_id"),
      //       trackId: uuidv4(),
      //       user_session: sessionStorage.getItem("user_session")
      //     };
      //     localStorage.setItem("referer_action_id",traceObj.trackId);
      //     trace({"traceObj":traceObj});
      //   }else{
        if(published!=='PUBLISHED'){
        const traceObj ={
            type: `get_subscribed_${requestData?.type}s`,
            event: 'click',
            message: `0 results found for accountId=${accountId}`,
            status: `Failed to get subscribed ${requestData?.type}s `,
            action: `clicked to get subscribed ${requestData?.type}s list`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }
          // }
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}

const MENU_APPS_PAGE_SIZE = 10;

export function* getMenuApps() {
  yield takeLatest(GET_MENU_APP_LIST, function* ({ requestData }) {
    const accountId = localStorage.getItem("accountId");
    const query = requestData?.query ?? "";
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId"),
        },
      };
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/subscribedApps?accountId=${accountId}&query=${query}&type=app&page=0&size=${MENU_APPS_PAGE_SIZE}`,
        config
      );
      if (res.status === 200) {
        const responseData = res.data || {};
        const content = Array.isArray(responseData.content)
          ? responseData.content
              .filter(
                (item) =>
                  item?.name !== `DeveloperApp_${accountId}` &&
                  item?.type !== "connector" &&
                  item?.type !== "service"
              )
              .slice(0, MENU_APPS_PAGE_SIZE)
          : [];
        yield put(
          menuAppList({
            ...responseData,
            content,
            totalElements: responseData.totalElements ?? content.length,
          })
        );
      }
    } catch (error) {
      console.log(error);
      yield put(menuAppList({ content: [], totalElements: 0 }));
    }
  });
}

export function* getDeveloperApp() {
  yield takeEvery(GET_DEVELOPER_APP, function* ({ payload }) {
    try {
      const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appName: `DeveloperApp_${accountId}`,
        },
      };
      const developerAppResponse = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/developerApp?appName=DeveloperApp_${accountId}&accountId=${accountId}`,
        config
      );
      if (developerAppResponse.status === 200) {
        // const traceObj ={
        //   type: `get_developer_app`,
        //   event: 'click',
        //   message: ` Developer App Retrieve successfully  For AccountId=${accountId}`,
        //   status: `Get Developer App successfully `,
        //   action: `clicked developer app`,
        //   referer_action_id: localStorage.getItem("referer_action_id"),
        //   trackId: uuidv4(),
        //   user_session: sessionStorage.getItem("user_session"),
        //   appName :  developerAppResponse?.data?.name,
        //   appId: developerAppResponse.data.appId,
        //   appInstanceId :  developerAppResponse.data.id
        //   }; 
        //   localStorage.setItem("referer_action_id",traceObj.trackId);
        //   trace({"traceObj":traceObj});
        var app = {};
        if (localStorage.getItem(AUTH_TOKEN) === undefined) {
          app["username"] = localStorage.getItem("username");
          app["userId"] = localStorage.getItem("userId");
          app["accountId"] = localStorage.getItem("accountId");
          app["accountUserId"] = localStorage.getItem("accountUserId");
          app["businessName"] = localStorage.getItem("businessName");
          app["accountCode"] = localStorage.getItem("accountCode");
          app["subscriptionId"] = developerAppResponse?.data?.id;
          app["appInstanceId"] = developerAppResponse?.data?.id;
          app["appId"] = developerAppResponse.data.appId;
          var code = Date.now();
          const tokenResponse = yield axios.post(
            `${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/appLoginAuthentication?code=${code}`,
            app,
            config
          );
          if (tokenResponse.status === 200) {
            localStorage.setItem(AUTH_TOKEN, tokenResponse.data.accessToken);
            localStorage.setItem("accountId", app.accountId);
            localStorage.setItem("appId", app.appId);
            localStorage.setItem("appInstanceId", app.id);
            localStorage.setItem("subscriptionId", app.id);
            yield put(developerApp(tokenResponse.data));
          }
        }
      }
    } catch (error) {
      // const traceObj ={
      //   type: `get_developer_app`,
      //   event: 'click',
      //   message: ` 0 results found`,
      //   status: `Failed To Get Developer App `,
      //   action: `clicked developer app`,
      //   referer_action_id: localStorage.getItem("referer_action_id"),
      //   trackId: uuidv4(),
      //   user_session: sessionStorage.getItem("user_session")
      //   }; 
      //   localStorage.setItem("referer_action_id",traceObj.trackId);
      //   trace({"traceObj":traceObj});
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* subscribeAppSettingsPage() {
  yield takeEvery(SUBSCRIBE_APP_SETTINGS_PAGE, function* ({ payload }) {
    try {
      payload["accountId"] = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };

      const appInstanceResonse = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance?userType=${localStorage.getItem("userType")}`,
        payload,
        config
      );
      if (appInstanceResonse.status === 200) {
        const status = payload?.status==='INACTIVE'?'unsubscribed':'subscribed';
        const traceObj ={
          type: `${status}_app`,
          event: 'click',
          message: `app ${status} ${payload?.subscriptionTerm} for appId=${payload?.appId} and subscribedId=${appInstanceResonse?.data?.data?.id}`,
          status: `app ${status} ${payload?.subscriptionTerm}`,
          action: `clicked app ${status}`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        if (appInstanceResonse.data.data.status === "ACTIVE") {
          Modal.success({
            title: `${t("impaqx.adminApp.subscribedSettingsMessage")}  ${payload.name}.`,
            content: `${t("impaqx.adminApp.subscriptionTerm")} : ${appInstanceResonse.data.data.subscriptionTerm}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(appInstaneData(appInstanceResonse?.data?.data))
        } else {
          Modal.info({
            title: `${t("impaqx.adminApp.unSubscribedMessage")} ${payload.name}.`,
            content: `${t("impaqx.adminApp.subscriptionTerm")} : ${appInstanceResonse.data.data.subscriptionTerm}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
              window.location.replace(`${PATH_VARIABLE}/app/${appInstanceResonse?.data?.data?.accountId}/${appInstanceResonse?.data?.data?.appId}/detialPage`);
            },
          });
        }
       }
      } catch (err) {
        const status = payload?.status==='INACTIVE'?'unsubscribed':'subscribed';
        const traceObj ={
          type: `${status}_app`,
          event: 'click',
          message: `Failed to ${status} ${payload?.subscriptionTerm} for app for appId=${payload?.appId}`,
          status: `Failed to ${status} ${payload?.subscriptionTerm} app`,
          action: `clicked app ${status}`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        console.log(err);
        yield put(showAppMessage(err?.response));
    }
  })
}

export function* subscribeAppDetailPage() {
  yield takeEvery(SUBSCRIBE_APP_DETAIL_PAGE, function* ({ payload }) {
    try {
      payload["accountId"] = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };

      const appInstanceResonse = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance?userType=${localStorage.getItem("userType")}`,
        payload,
        config
      );
      if (appInstanceResonse.status === 200) {
        const traceObj ={
          type: `subscribe_${payload?.type}_detail_page`,
          event: 'click',
          message: `${payload?.type} detail settings page subscribed for subscribedId=${payload?.id}`,
          status: `${payload?.type} settings page subscribed`,
          action: `Clicked ${payload?.type} settings page`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        if (appInstanceResonse.data.data.status == "ACTIVE") {
          Modal.success({
            title: `${t("impaqx.adminApp.subscribedMessage")}  ${payload.name}.`,
            content: `${t("impaqx.adminApp.subscriptionTerm")} : ${appInstanceResonse.data.data.subscriptionTerm}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              window.location.replace(`${PATH_VARIABLE}/app/${appInstanceResonse?.data?.data?.accountId}/${appInstanceResonse?.data?.data?.appId}/${appInstanceResonse?.data?.data?.id}/detialPage`);
            },
          });
        } else {
          Modal.info({
            title: `${t("impaqx.adminApp.unSubscribedMessage")} ${payload.name}.`,
            content: `${t("impaqx.adminApp.subscriptionTerm")} : ${appInstanceResonse.data.data.subscriptionTerm}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              window.location.replace(`${PATH_VARIABLE}/app/${appInstanceResonse?.data?.data?.accountId}/${appInstanceResonse?.data?.data?.appId}/detialPage`);
            },
          });
        }
       }
      } catch (err) {
        const traceObj ={
          type: `subscribe_${payload?.type}_detail_page`,
          event: 'click',
          message: ` Failed to subscribe ${payload?.type} detail settings page for and subscribedId=${payload?.id}`,
          status: `Failed to subscribe ${payload?.type} detail settings page`,
          action: `clicked ${payload?.type} settings page`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        console.log(err);
        yield put(showAppMessage(err?.response));
    }
  })
}

export function* subscribeApp() {
  yield takeEvery(SUBSCRIBE_APP, function* ({ payload }) {
    try {
      payload["accountId"] = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };

      const appInstanceResonse = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance?userType=${localStorage.getItem("userType")}`,
        payload,
        config
      );
      if (appInstanceResonse.status === 200) {
        const traceObj ={
          type: `subscribe_${payload?.type}`,
          event: 'click',
          message: ` ${payload?.type} subscribed for userType=${localStorage.getItem("userType")} and subscribedId=${payload?.id}`,
          status: `${payload?.type} is subscribed`,
          action: `clicked to subscribe ${payload?.type}`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        if (appInstanceResonse.data.data.status === "ACTIVE") {
          Modal.success({
            title: `${t("impaqx.adminApp.subscribedMessage")}  ${payload.name}.`,
            content: `${t("impaqx.adminApp.subscriptionTerm")} : ${appInstanceResonse.data.data.subscriptionTerm}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
        } else {
          Modal.info({
            title: `${t("impaqx.adminApp.unSubscribedMessage")} ${payload.name}.`,
            content: `${t("impaqx.adminApp.subscriptionTerm")} : ${appInstanceResonse.data.data.subscriptionTerm}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
        }
        const accountId = localStorage.getItem("accountId");
        const config = {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            accountId: localStorage.getItem("accountId"),
            appInstanceId: localStorage.getItem("appInstanceId"),
            accountUserId: localStorage.getItem("accountUserId")
          },
        };
        const res = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountUser-appInstanceRole?accountUserId=${localStorage.getItem("accountUserId")}`,
          config
        );
        if (res.status === 200) {
          yield put(accountUserAppInstanceRoles(res.data));
        }
        const subscribedAppResponse = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/subscribedApps?accountId=${accountId}&type=${payload?.type}&query=`,
          config
        );
        if (subscribedAppResponse.status === 200) {
          yield put(subscribedAppList(subscribedAppResponse.data));
        } else {
          yield put(showAppMessage(subscribedAppResponse));
        }

        yield put(registerSuccess(appInstanceResonse));
      } else {
        yield put(showAppMessage(appInstanceResonse));
      }
    } catch (err) {
      const traceObj ={
        type: `subscribe_${payload?.type}`,
        event: 'click',
        message: `Failed to subscribe ${payload?.type} for subscribedId=${payload?.id}`,
        status: `Failed to subscribe ${payload?.type}`,
        action: `clicked subscribe ${payload?.type}`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
        }; 
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(err);
      yield put(showAppMessage(err?.response));
    }
  });
}

export function* editApp() {
  yield takeEvery(EDIT_APP, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/app/${payload}`,
        config
      );
      if (res.status === 200) {
        const type=payload?.type?payload?.type:'app';
        const traceObj ={
          type: `get_${type}`,
          event: 'click',
          message: `${type} get successfully  for id=${payload}`,
          status: `${type} get successfully `,
          action: `Clicked get ${type}`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        yield put(app(res.data));
      }
    } catch (error) {
      const type=payload?.type?payload?.type:'app';
      const traceObj ={
        type: `edit_${type}`,
        event: 'click',
        message: `Failed to get ${type} for id=${payload}`,
        status: `Failed to get ${type}`,
        action: `Clicked get ${type}`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
        }; 
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* appRegister() {
  yield takeEvery(SAVE_APP, function* ({ payload }) {
    try {
      const accountId = localStorage.getItem("accountId");
      const parentAppId = localStorage.getItem("parentAppId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const appRegResponse = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/app`,
        payload,
        config
      );
      if (appRegResponse.status === 200) {
        const traceObj ={
          type: `${payload?.type}_register`,
          event: 'click',
          message: `${payload?.type} registered successfully  for name=${payload?.name}`,
          status: `${payload?.type} registered successfully `,
          action: `Clicked ${payload?.type} to register`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        if (payload.name.startsWith("DeveloperApp")) {
          let subscribeData = {};
          subscribeData["accountId"] = localStorage.getItem("accountId");
          subscribeData["appId"] = appRegResponse.data.id;
          subscribeData["status"] = "ACTIVE";
          subscribeData["userCreated"] = localStorage.getItem("userId");
          subscribeData["userUpdated"] = localStorage.getItem("userId");
          subscribeData["subscriptionTerm"] = "ALLTIME";
          subscribeData["subscriptionRenewalTerm"] = "ALLTIME";
          const developerAppInstanceResponse = yield axios.post(
            `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance?userType=${localStorage.getItem("userType")}`,
            subscribeData,
            config
          );
          if (developerAppInstanceResponse.status === 200) {
            const listType = payload?.type || "app";
            const pagination = payload?.pagination || { current: 1, pageSize: 10 };
            const resolvedParentAppId =
              payload?.parentAppId || localStorage.getItem("parentAppId");
            const appsResponse = yield axios.get(
              `${API_BASE_DEVELOPER_APP}/developerApp/apps?accountId=${accountId}&parentAppId=${resolvedParentAppId}&query=&sortfield=${DEFAULT_APPS_SORT_FIELD}&sortorder=${DEFAULT_APPS_SORT_ORDER}&page=${
                pagination.current - 1
              }&size=${pagination.pageSize}&type=${listType}`,
              config
            );
            if (appsResponse.status === 200) {
              const responseData = appsResponse.data || {};
              const developerAppName = `DeveloperApp_${accountId}`;
              const content = Array.isArray(responseData.content)
                ? responseData.content.filter(
                    (item) => item?.name !== developerAppName
                  )
                : [];
              Modal.success({
                title: t("impaqx.adminApp.developerPortalSuccessMessage"),
                icon: <CheckCircleFilled />,
                okText: t("impaqx.adminApp.close"),
                onOk() {
                  //deleteApp(id);
                },
              });
              yield put(apps({ ...responseData, content }, listType));
            }
          }
        } else {
          Modal.success({
            title: t("impaqx.adminApp.appSuccessMessage").replace("App",payload?.type),
            icon: <CheckCircleFilled />,
            okText:t("impaqx.adminApp.close"),
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(registerSuccess(appRegResponse));
        }
      } else {
        yield put(showAppMessage(appRegResponse));
      }
    } catch (err) {
      const traceObj ={
        type: `${payload?.type}_register`,
        event: 'click',
        message: ` Failed to register ${payload?.type} name=${payload?.name}`,
        status: `Failed to register ${payload?.type}`,
        action: `Clicked ${payload?.type} to register`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
        }; 
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(err);
      yield put(showAppMessage(err?.response));
    }
  });
}

export function* deleteApp() {
  yield takeEvery(DELETE_APP, function* ({ payload }) {
    try {
      const accountId = localStorage.getItem("accountId");
      const parentAppId = localStorage.getItem("parentAppId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.delete(
        `${API_BASE_DEVELOPER_APP}/developerApp/app/${payload.id}`,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `delete_${payload?.type}`,
          event: 'click',
          message: `${payload?.type} deleted for id=${payload.id}`,
          status: `${payload?.type} deleted`,
          action: `Clicked delete ${payload?.type}`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        //yield put(showAccountMessage(res));
        if(payload?.type=='addModule'){
          const name = btoa(localStorage.getItem("parentAppName"));
          window.replace(`/app/pages/edit-app/${localStorage.getItem("parentAppId")}?type=app&name=${name}`);
        }
        const { sortField, sortOrder } = resolveAppsSortParams(payload?.sorter);
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/apps?accountId=${accountId}&parentAppId=${parentAppId}&query=${
            payload?.query ?? ""
          }&sortfield=${sortField}&sortorder=${sortOrder}&page=${(payload?.pagination?.current ?? 1) - 1}&size=${
            payload?.pagination?.pageSize ?? 10
          }&type=${
            payload?.type
          }`,
          config
        );
        if (response.status === 200) {
           Modal.success({
            title: `${payload.name}  ${t("impaqx.adminApp.appDeleteMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(apps(response.data));
        }
      }
    } catch (error) {
      const traceObj ={
        type: `delete_${payload?.type}`,
        event: 'click',
        message: `Failed to delete ${payload?.type} id=${payload.id}`,
        status: `Failed to delete ${payload?.type}`,
        action: `Clicked to delete ${payload?.type}`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
        }; 
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* getMfaSetupHome() {
  yield takeEvery(GET_MFA_SETUP_HOME, function* ({ username }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.get(
        `${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/mfasetup?username=${username}`,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `get_mfa_setup`,
          event: 'click',
          message: `Mfa setup retrive successfully  for userId=${localStorage.getItem("userId")}`,
          status: `Mfa setup retrive successfully `,
          action: `Clicked mfa setup`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        yield put(twoFactorPageSuccess(res.data));
      }
    } catch (error) {
      const traceObj ={
        type: `get_mfa_setup`,
        event: 'click',
        message: `Failed to retrive Mfa setup for userId=${localStorage.getItem("userId")}`,
        status: `Failed to retrive Mfa setup`,
        action: `Clicked mfa Setup`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
        }; 
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(error.response);
      yield put(showAppMessage(error?.response));
    }
  });
}
export function* appLoginAuthentication() {
  yield takeEvery(APP_LOGIN_AUTHENTICATION, function* ({ app }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      var appData = {};
      appData["username"] = localStorage.getItem("username");
      appData["userId"] = localStorage.getItem("userId");
      appData["accountId"] = localStorage.getItem("accountId");
      appData["accountUserId"] = localStorage.getItem("accountUserId");
      appData["businessName"] = localStorage.getItem("businessName");
      appData["accountCode"] = localStorage.getItem("accountCode");
      appData["appInstanceId"] = app.id;
      appData["subscriptionId"] = app.id;
      appData["appId"] = app.appId;
      var code = Date.now();
      const res = yield axios.post(
        `${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/appLoginAuthentication?code=${code}`,
        appData,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `open_app`,
          event: 'click',
          message: `App Login Successfully for AppInstance=${app?.name}`,
          status: `App accessed successfully`,
          action: `Clicked on ${app?.name} app`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session"),
          appName :  app?.name,
          appId: app?.appId,
          appInstanceId :  app?.id
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        localStorage.setItem(AUTH_TOKEN, res.data.accessToken);
        localStorage.setItem("accountId", res.data.accountId);
        localStorage.setItem("appId", res.data.appId);
        localStorage.setItem("appInstanceId", res.data.subscriptionId);
        localStorage.setItem("subscriptionId", res.data.subscriptionId);
        const tab = window.open(app.accessUrl + "?code=" + code, "_blank");
        if (tab) {
          tabRefs.push(tab);
        }
      	yield put(showAppMessage(res));
      }
    } catch (error) {
      const traceObj ={
        type: `open_app`,
        event: 'click',
        message: `App Login failed for AppInstance=${app?.name}`,
        status: `Failed to opened the app`,
        action: `Clicked on ${app?.name} app`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session"),
        appName :  app?.name,
        appId: app?.appId,
        appInstanceId :  app?.id
        }; 
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(error.response);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* onUsing2fa() {
  yield takeEvery(USING_2FA, function* ({ using2fa }) {
    const username = localStorage.getItem("username");
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/using2fa?using2fa=${using2fa}&username=${username}`,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `onUsing2fa`,
          event: 'click',
          message: `onUsing2fa for username=${username}`,
          status: `onUsing2fa is successfully `,
          action: `Clicked onUsing2fa`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        yield put(toggle2fa(using2fa));
      }
    } catch (error) {
      const traceObj ={
        type: `onUsing2fa`,
        event: 'click',
        message: `onUsing2fa failed for username=${username}`,
        status: `onUsing2fa failed`,
        action: `Clicked onUsing2fa`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
        }; 
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(error.response);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* getUsing2faValue() {
  yield takeEvery(GET_USING_2FA_VALUE, function* ({ using2fa }) {
    const username = localStorage.getItem("username");
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_URL}${MANAGE_PREPIX_PATH}${API}${VERSION}${USERS_PREPIX_PATH}/getUsing2fa?username=${username}`,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `get_using2faValue`,
          event: 'click',
          message: `successfully  getUsing2faValue for username=${username}`,
          status: `successfully  getUsing2faValue`,
          action: `Clicked to getUsing2faValue`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
          yield put(toggle2fa(res.data));
      }
    } catch (error) {
      const traceObj ={
        type: `get_using2faValue`,
        event: 'click',
        message: `Failed to getUsing2faValue for username=${username}`,
        status: `Failed to getUsing2faValue`,
        action: `Clicked to getUsing2faValue`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
        }; 
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(error.response);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* addAppPermission() {
  yield takeEvery(ADD_APP_PERMISSION, function* ({ payload }) {
    try {
      const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/appPermission`,
        payload,
        config
      );
      if (res.status === 200) {
          const traceObj ={
          type: `add_app_permission`,
          event: 'click',
          message: `App permission added successfully  for appId=${payload?.appId} and id=${res?.data?.id}`,
          status: `App permission added`,
          action: `Clicked add app permission`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
            const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/appPermissions?appId=${
            res?.data?.permission?.appId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: t("impaqx.adminApp.permissionCreateSuccessMessage"),
            icon: <CheckCircleFilled />,
            okText: t("impaqx.adminApp.close"),
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
        }
        yield put(appPermissions(response.data));
        yield put(setAddEdit(false));
      }
    } catch (err) {
      const traceObj ={
        type: `add_app_permission`,
        event: 'click',
        message: `Failed to add app permission for appId=${payload?.appId} and id=${payload?.name}`,
        status: `Failed to add app permission`,
        action: `Clicked add app permission`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
        }; 
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(err);
      yield put(showAppMessage(err?.response));
    }
  });
}

export function* addAppRole() {
  yield takeEvery(ADD_APP_ROLE, function* ({ payload }) {
    try {
      const { values, checkedPermission } = payload;
      //const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appId:values?.appId,
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/appDefaultUserRole`,
        values,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `add_app_role`,
          event: 'click',
          message: `App role added successfully  for appId=${payload?.appId} and id=${payload?.name}`,
          status: `App role added successfully `,
          action: `Clicked to add app role`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        var appDefaultUserRolePermissionData = {};
        if (res.data.appDefaultUserRole) {
          Modal.success({
            title: t("impaqx.adminApp.roleCreatedSuccessMessage"),
            icon: <CheckCircleFilled />,
            okText: t("impaqx.adminApp.close"),
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          const appRoleResponse = yield axios.get(
            `${API_BASE_DEVELOPER_APP}/developerApp/appDefaultUserRoles?appId=${
              res?.data?.appDefaultUserRole?.appId
            }&userType=${payload?.userType}&query=${payload?.query}&sortfield=${
              payload?.sorter?.field
            }&sortorder=${payload?.sorter?.order}&page=${
              payload?.pagination?.current - 1
            }&size=${payload?.pagination?.pageSize}`,
            config
          );
          if (appRoleResponse.status === 200) {
            yield put(appRoles(appRoleResponse.data));
            yield put(setAddEdit(false));
          }
          appDefaultUserRolePermissionData["appDefaultUserRolesId"] =
            res.data.appDefaultUserRole.id;
          // appDefaultUserRolePermissionData["status"]="ACTIVE";
          appDefaultUserRolePermissionData["userCreated"] =
            localStorage.getItem("userId");
          appDefaultUserRolePermissionData["userUpdated"] =
            localStorage.getItem("userId");
          // Object.keys(checkedPermission).forEach(function(appPermissionId) {
          // 	appDefaultUserRolePermissionData["appPermissionsId"]=appPermissionId;
          appDefaultUserRolePermissionData["checkedPermission"] =
            checkedPermission;
          const response = yield axios.post(
            `${API_BASE_DEVELOPER_APP}/developerApp/appDefaultUserRolePermission`,
            appDefaultUserRolePermissionData,
            config
          );
          if (response.status === 200) {
            //	yield put(apps(response.data));
          }
          //});
        }
      }
    } catch (err) {
      const traceObj ={
        type: `add_app_role`,
        event: 'click',
        message: `Failed to add app role for appId=${payload?.appId} and id=${payload?.name}`,
        status: `Failed to add app role`,
        action: `Clicked add app role`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
        }; 
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(err);
      yield put(showAppMessage(err?.response));
    }
  });
}

export function* getAppPermissions() {
  yield takeEvery(GET_APP_PERMISSIONS, function* ({ payload }) {
    // const userId = localStorage.getItem("id")
    //const accountId = localStorage.getItem("accountId")
    const {query} = payload ;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/appPermissions?appId=${
          payload?.appId
        }&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        if(query!==undefined && query!==""){
					const traceObj ={
							type: `get_app_permissions`,
							event: 'click',
							message: `${res?.data?.totalElements} results found for keyword=${payload?.query} and appId=${payload?.appId}`,
							status: ` App permission retrive successfully `,
							action: `Clicked get app permissions`,
							referer_action_id: localStorage.getItem("referer_action_id"),
							trackId: uuidv4(),
							user_session: sessionStorage.getItem("user_session")
						};
						localStorage.setItem("referer_action_id",traceObj.trackId);
						trace({"traceObj":traceObj});
					}else{
            const traceObj ={
							type: `get_app_permissions`,
							event: 'click',
							message: `${res?.data?.totalElements} results found for appId=${payload?.appId}`,
							status: `App permission retrive successfully `,
							action: `Clicked to get app permissions`,
							referer_action_id: localStorage.getItem("referer_action_id"),
							trackId: uuidv4(),
							user_session: sessionStorage.getItem("user_session")
						};
						localStorage.setItem("referer_action_id",traceObj.trackId);
						trace({"traceObj":traceObj});
					}
          yield put(appPermissions(res.data));
      }
    } catch (err) {
      if(query!==undefined && query!==""){
        const traceObj ={
            type: `get_app_permissions`,
            event: 'click',
            message: `0 results found for keyword=${payload?.query} and appId=${payload?.appId}`,
            status: ` Failed to retrieve app permission`,
            action: `Clicked get app permissions`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }else{
          const traceObj ={
            type: `get_app_permissions`,
            event: 'click',
            message: `0 results found for appId=${payload?.appId}`,
            status: `Failed to retrieve app permission`,
            action: `Clicked get app permissions`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }
      console.log(err);
      yield put(showAppMessage(err?.response));
    }
  });
}

export function* getAppRoles() {
  yield takeEvery(GET_APP_ROLES, function* ({ payload }) {
    const userId = localStorage.getItem("id");
    const accountId = localStorage.getItem("accountId");
    const {query } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/appDefaultUserRoles?appId=${
          payload?.appId
        }&appName=${
          payload?.appName
        }&userType=${payload?.userType}&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        if(!payload?.invite)
        if(query!==undefined && query!==""){
					const traceObj ={
							type: `get_app_roles`,
							event: 'click',
							message: `${res?.data?.totalElements} results found for keyword=${payload?.query} and appId=${payload?.appId}`,
							status: ` App role retrive successfully `,
							action: `Clicked app roles`,
							referer_action_id: localStorage.getItem("referer_action_id"),
							trackId: uuidv4(),
							user_session: sessionStorage.getItem("user_session")
						};
						localStorage.setItem("referer_action_id",traceObj.trackId);
						trace({"traceObj":traceObj});
					}else{
            const traceObj ={
							type: `get_app_roles`,
							event: 'click',
							message: `${res?.data?.totalElements} results found and appId=${payload?.appId}`,
							status: ` App role retrive successfully `,
							action: `Clicked app roles`,
							referer_action_id: localStorage.getItem("referer_action_id"),
							trackId: uuidv4(),
							user_session: sessionStorage.getItem("user_session")
						};
						localStorage.setItem("referer_action_id",traceObj.trackId);
						trace({"traceObj":traceObj});
					}
        yield put(appRoles(res.data));
      }
    } catch (err) {
      if(!payload?.invite)
      if(query!==undefined && query!==""){
        const traceObj ={
            type: `get_app_roles`,
            event: 'click',
            message: `0 results found for keyword=${payload?.query} and appId=${payload?.appId}`,
            status: ` App role retrive successfully `,
            action: `Clicked app roles`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }else{
        const traceObj ={
          type: `get_app_roles`,
          event: 'click',
          message: `0 result found fro appId=${payload?.appId}`,
          status: ` Failed to retrive app role`,
          action: `Clicked app roles`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        }
      console.log(err);
      yield put(showAppMessage(err?.response));
    }
  });
}

export function* deleteAppPermission() {
  yield takeEvery(DELETE_APP_PERMISSION, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.delete(
        `${API_BASE_DEVELOPER_APP}/developerApp/appPermission/${payload?.id}`,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `delete_app_permission`,
          event: 'click',
          message: `App permission deleted successfully  for id=${payload?.id} and appId=${payload?.appId}`,
          status: ` App permissions retrive successfully `,
          action: `Clicked delete app permissions`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        //yield put(showAccountMessage(res));
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/appPermissions?appId=${
            payload?.appId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${payload.permission}  ${t("impaqx.adminApp.deletePermissionMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(appPermissions(response.data));
        }
      }
    } catch (error) {
      const traceObj ={
        type: `delete_app_permission`,
        event: 'click',
        message: ` Failed to delete app permission for id=${payload.id} and appId=${payload?.appId}`,
        status: ` Failed to delete app permission`,
        action: `Clicked delete app permissions`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* updateAppPermission() {
  yield takeEvery(UPDATE_APP_PERMISSION, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/appPermission/${payload.id}`,
        payload,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `update_app_permission`,
          event: 'click',
          message: `App permissions updated successfully  for id=${payload.id} and appId=${payload?.appId}`,
          status: ` App permissions updated successfully `,
          action: `Clicked to update app permissions`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/appPermissions?appId=${
            res?.data?.appId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${payload.permission}  ${t("impaqx.adminApp.updatePermissionMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(appPermissions(response.data));
          yield put(setAddEdit(false));
        }
      }
    } catch (error) {
      const traceObj ={
        type: `update_app_permission`,
        event: 'click',
        message: `Failed to update app permissions for id=${payload.id} and appId=${payload?.appId}`,
        status: `Failed to update app permissions`,
        action: `Clicked to update app permissions`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* deleteAppRole() {
  yield takeEvery(DELETE_APP_ROLE, function* ({ payload }) {
    const {query } = payload;
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appId:payload?.appId,
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.delete(
        `${API_BASE_DEVELOPER_APP}/developerApp/appDefaultUserRole/${payload.id}`,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `delete_app_role`,
          event: 'click',
          message: `App role deleted for id=${payload.id} and appId=${payload?.appId}`,
          status: `App role deleted successfully`,
          action: `Clicked to delete app role`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        //yield put(showAccountMessage(res));
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/appDefaultUserRoles?appId=${
            payload?.appId
          }&userType=${payload?.userType}&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${payload.roleName}  ${t("impaqx.adminApp.roleDeleteMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(appRoles(response.data));
        }
      }
    } catch (error) {
      const traceObj ={
        type: `delete_app_role`,
        event: 'click',
        message: `Failed to delete app role for id=${payload?.id} and appId=${payload?.appId}`,
        status: `Failed to delete app role`,
        action: `Clicked to delete app role`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(error);
      if(error?.response?.status==403)
      Modal.error({
        title: t("impaqx.adminApp.roleDeletedErrorMessage"),
        icon: <WarningFilled />,
        okText: t("impaqx.adminApp.close"),
        //cancelText: 'Cancel',
        onOk() {
          //deleteApp(id);
        },
      });
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* updateAppRole() {
  yield takeEvery(UPDATE_APP_ROLE, function* ({ payload }) {
    const {query } = payload;
    try {
      const { values, checkedPermission } = payload;
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appId:values?.appId,
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/appDefaultUserRole/${values.id}`,
        values,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `update_app_role`,
          event: 'click',
          message: `App role updated for id=${values.id} and appId=${values?.appId}`,
          status: `App role updated successfully`,
          action: `Clicked update app role`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        //const response = yield  axios.get(`${API_BASE_DEVELOPER_APP}/developerApp/appDefaultUserRoles?appId=${res?.data?.appId}&query=${payload?.query}&sortfield=${payload?.sorter?.field}&sortorder=${payload?.sorter?.order}&page=${payload?.pagination?.current-1}&size=${payload?.pagination?.pageSize}`);
        //if (response.status===200) {
        var appDefaultUserRolePermissionData = {};
        appDefaultUserRolePermissionData["appDefaultUserRolesId"] =
          res.data.appDefaultUserRole.id;
        // appDefaultUserRolePermissionData["status"]="ACTIVE";
        appDefaultUserRolePermissionData["userCreated"] =
          localStorage.getItem("userId");
        appDefaultUserRolePermissionData["userUpdated"] =
          localStorage.getItem("userId");
        // Object.keys(checkedPermission).forEach(function(appPermissionId) {
        // 	appDefaultUserRolePermissionData["appPermissionsId"]=appPermissionId;
        appDefaultUserRolePermissionData["checkedPermission"] =
          checkedPermission;
        const response = yield axios.post(
          `${API_BASE_DEVELOPER_APP}/developerApp/appDefaultUserRolePermission`,
          appDefaultUserRolePermissionData,
          config
        );
        if (response.status === 200) {
          //	yield put(apps(response.data));
          Modal.success({
            title: `${values.roleName}  ${t("impaqx.adminApp.permissionUpdateMessage")}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
        }
        const appRoleResponse = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/appDefaultUserRoles?appId=${
            res?.data?.appDefaultUserRole?.appId
          }&userType=${payload?.userType}&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (appRoleResponse.status === 200) {
            const traceObj ={
                type: `app_role_list`,
                event: 'navigation',
							  message: `${res?.data?.totalElements} results found for appId=${payload?.appId}`,
                status: ` App default user roles retrive successfully `,
                action: `Clicked update app role`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
              };
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
          yield put(setAddEdit(false));
          yield put(appRoles(appRoleResponse.data));
        }
      }
    } catch (error) {
      const traceObj ={
        type: `update_app_role`,
        event: 'click',
        message: `Failed to update app role for roleId=${payload?.id} and appId=${payload?.appId}`,
        status: `Failed to update app role`,
        action: `Clicked update app role`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* getAppRolePermissions() {
  yield takeLatest(GET_APP_ROLE_PERMISSIONS, function* ({ payload }) {
    const userId = localStorage.getItem("id");
    const accountId = localStorage.getItem("accountId");
    const {query } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/appDefaultUserRolePermissons?appRoleId=${
          payload?.appRoleId
        }&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        if(query!==undefined && query!==""){
          const traceObj ={
              type: `get_app_role_permissions`,
              event: 'click',
              message: `${res?.data?.totalElements} for keyword=${payload?.query} and appRoleId=${payload?.appRoleId}`,
              status: ` App role permissions retrive successfully `,
              action: `Clicked to get app role permissions`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }else{
            const traceObj ={
              type: `get_app_role_permissions`,
              event: 'click',
              message: `${res?.data?.totalElements} for appRoleId=${payload?.appRoleId}`,
              status: `App role permissions retrive successfully `,
              action: `Clicked to get app role permissions`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }
        yield put(appRolePermissions(res.data));
      }
    } catch (err) {
      if(query!==undefined && query!==""){
        const traceObj ={
            type: `get_app_role_permissions`,
            event: 'click',
            message: `0 Result found keyword=${payload?.query} and appRoleId=${payload?.appRoleId}`,
            status: `Failed to retrive app role permissions`,
            action: `Clicked get app role permissions`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }else{
          const traceObj ={
            type: `get_app_role_permissions`,
            event: 'click',
            message: `0 Result found appRoleId=${payload?.appRoleId}`,
            status: ` Failed to retrive app role permissions`,
            action: `Clicked get app role permissions`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }
      console.log(err);
      yield put(showAppMessage(err?.response));
    }
  });
}

export function* addAppSettingsReactJson() {
  yield takeEvery(ADD_APP_SETTINGS_JSON, function* ({ payload }) {
    const { id, settingsSchema, settingsDefaultValues } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    var body ={
      [`settingsSchema`]: settingsSchema,

      [`settingsDefaultValues`]: settingsDefaultValues,
      ['userUpdated'] : localStorage.getItem("userId")
    }
    try {
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/app/settings/${id}`,
        body
        ,
        config
      );

      if (res.status === 200) {
        const res1 = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/app/${id}`,
          config
        );
  
        if (res1.status === 200) {
          const traceObj ={
            type: `get_application_settings_details`,
            event: 'click',
            message: `App settings react Json fetched for appId=${id}`,
            status: ` Application settings details retrieve successfully `,
            action: `Clicked get application settings details`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
          yield put(appSettingsJson(res1.data));
        }
        const traceObj ={
          type: `add_app_settings_json`,
          event: 'click',
          message: `App settings react Json added for appId=${id}`,
          status: ` App settings react Json sdded`,
          action: `Clicked to add app settings json`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        // yield put(appSettingsJson(res.data));

        Modal.success({
          title: "Form configuration updated successfully",

          icon: <CheckCircleFilled />,

          okText: "Close",
        });
      }
    } catch (err) {
      const traceObj ={
        type: `add_app_settings_json`,
        event: 'click',
        message: `Failed to add app settings Json for appId=${id}`,
        status: `Failed to add app settings Json`,
        action: `Clicked to add app settings json`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(err);

      yield put(showAppMessage(err?.response));
    }
  });
}

export function* getApplicationSettingsDetails() {
  yield takeEvery(GET_APP_SETTINGS_DETAILS, function* ({ payload }) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/app/${payload}`,
        config
      );

      if (res.status === 200) {
        const traceObj ={
          type: `get_application_settings_details`,
          event: 'click',
          message: `App settings react Json fetched for appId=${payload}`,
          status: ` Application settings details retrieve successfully `,
          action: `Clicked get application settings details`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        yield put(appSettingsJson(res.data));
      }
    } catch (error) {
      const traceObj ={
        type: `get_application_settings_details`,
        event: 'click',
        message: `Failed to ferch app settings react Json for appId=${payload}`,
        status: `Failed to retrieve application settings details`,
        action: `Clicked get application settings details`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(error);

      yield put(showAppMessage(error?.response));
    }
  });
}

export function* getAppInstance() {
  yield takeEvery(GET_APP_INSTANCE_DATA, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/app/appInstance/${payload}`,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `get_application_instance`,
          event: 'click',
          message: `App instance or subscription fetched for subscribedId=${payload}`,
          status: ` App instance or subscription retrieve successfully `,
          action: `Clicked to get app instance or subscription`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        yield put(appData(res.data));
      }
    } catch (error) {
      const traceObj ={
        type: `get_application_instance`,
        event: 'click',
        message: `Failed to fetch App instance or subscription  for subscribedId=${payload}`,
        status: ` Failed To Retrieve App Instance or subscription successfully `,
        action: `Clicked get app instance or subscription`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* getAdminAppUiPropertiesDetails() {
  yield takeEvery(GET_ADMIN_APP_UI_PROPERTIES, function* ({ payload }) {
    const {query } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const response = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/parent-app?appName=AdminApp`, {headers: {
          'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          'Content-Type': 'application/json',
          'accountId':localStorage.getItem("accountId"),
          'appInstanceId':localStorage.getItem("appInstanceId"),
          'accountUserId':localStorage.getItem("accountUserId")
        }});
      if (response.status === 200) {
          const res = yield axios.get(
            `${API_BASE_DEVELOPER_APP}/developerApp/properties/admin-ui-properties?appId=${response?.data?.id}&query=&sortfield=undefined&sortorder=undefined&useMongo=false`,
            {headers: {
              'Authorization': `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
              'Content-Type': 'application/json'
            }}
          );
          //`${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-proerties?appId=${appId}&query=${queryString}&sortfield=${sortField}&sortorder=${sortorder}`,
          if (res.status === 200) {
            if(query!==undefined && query!==""){
              const traceObj ={
                  type: `admin_app_ui_properties_details_search`,
                  event: 'click',
                  message: `${res?.data?.totalElements} results found for keyword=${payload?.query} and appId=${payload?.appId}`,
                  status: `Admin app Ui properties details retrive successfully `,
                  action: `Search admin app ui properties details`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
                };
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
              }else{
                const traceObj ={
                  type: `get_app_role_permissions`,
                  event: 'click',
                  message: `${res?.data?.totalElements} results found for appId=${payload?.appId}`,
                  status: ` Admin app Ui properties details retrive ssuccessfully `,
                  action: `Clicked to admin app ui properties details`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
                };
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
              }
            const enData = {};
            const frData = {};
            const spData = {};
            const jpData = {};
            res.data &&
            res.data.map((uiDetails, index) => {
              if (uiDetails.locale) {
                enData[`${uiDetails.propertyName}`] = uiDetails?.locale?.en;
                frData[`${uiDetails.propertyName}`] = uiDetails?.locale?.fr;
                spData[`${uiDetails.propertyName}`] = uiDetails?.locale?.sp;
                jpData[`${uiDetails.propertyName}`] = uiDetails?.locale?.jp;
              }
            });
            localStorage.setItem("ENGLISH-DATA", JSON.stringify(enData));
            localStorage.setItem("FRENCH-DATA", JSON.stringify(frData));
            localStorage.setItem("SPANISH-DATA", JSON.stringify(spData));
            localStorage.setItem("JAPNESE-DATA", JSON.stringify(jpData));
            //yield put(uiPropertiesJson([...res.data]));
          }
        }
    } catch (error) {
      if(query!==undefined && query!==""){
        const traceObj ={
            type: `admin_app_ui_properties_details_search`,
            event: 'click',
            message: `0 results found for keyword=${payload?.query} and appId=${payload?.appId}`,
            status: ` Failed to retrive admin app Ui properties details`,
            action: `Search admin app ui properties details`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }else{
          const traceObj ={
            type: `get_app_role_permissions`,
            event: 'click',
            message: `0 results found for appId=${payload?.appId}`,
            status: ` Failed to retrive admin app Ui properties details`,
            action: `Clicked to admin app ui properties details`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}

export function* getUiProperties() {
  yield takeEvery(APP_UI_PROPERTY, function* ({ payload }) {
    const { appId, query, sorter,pagination } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-properties?appId=${appId}&query=${query}&sortfield=${sorter?.field}&sortorder=${sorter?.order}&page=${pagination?.current - 1}&size=${pagination?.pageSize}&useMongo=false`,
        config
      );
      //`${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-proerties?appId=${appId}&query=${queryString}&sortfield=${sortField}&sortorder=${sortorder}`,
      if (res.status === 200) {
        if(query!==undefined && query!==""){
          const traceObj ={
              type: `search_ui_properties`,
              event: 'click',
              message: `${res?.data?.totalElements} results found for keyword=${payload?.query} and appId=${payload?.appId}`,
              status: `Ui properties retrive successfully `,
              action: `Search ui properties`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }else{
            const traceObj ={
              type: `get_ui_properties`,
              event: 'click',
              message: `${res?.data?.totalElements} results found for  appId=${payload?.appId}`,
              status: ` Ui properties retrieve successfully `,
              action: `Clicked get ui properties`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }
        yield put(uiPropertiesJson(res.data));
      }
    } catch (error) {
      if(query!==undefined && query!==""){
        const traceObj ={
            type: `search_ui_properties`,
            event: 'click',
            message: `0 results found for keyword=${payload?.query} and appId=${payload?.appId}`,
            status: `Failed to retrieve Ui properties`,
            action: `Search ui properties Failed`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }else{
          const traceObj ={
            type: `get_ui_properties`,
            event: 'click',
            message: `0 results found for appId=${payload?.appId}`,
            status: ` Failed to retrieve Ui properties`,
            action: `Clicked to get app ui properties details`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}
export function* addAUiPropertiesData() {
  yield takeEvery(ADD_APP_UI_PROPERTY, function* ({ payload }) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-property`,
        payload,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `add_ui_properties_data`,
          event: 'click',
          message: `Ui properties added successfully  with id=${res?.data?.id} and appId=${payload?.appId}`,
          status: ` Ui properties added successfully `,
          action: `Clicked to add ui properties data`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        if(payload?.appId){
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-properties?appId=${payload?.appId}&query=&sortfield=undefined&sortorder=undefined&useMongo=false`,
          config
        );
        //`${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-proerties?appId=${appId}&query=${queryString}&sortfield=${sortField}&sortorder=${sortorder}`,
        if (response.status === 200) {
          yield put(uiPropertiesJson(response.data));
        }
      }
        Modal.success({
          title: t("impaqx.adminApp.propertyAddMessage"),
          icon: <ExclamationCircleOutlined />,
          okText: "Close",
        });
      }
    } catch (err) {
      const traceObj ={
        type: `add_ui_properties_data`,
        event: 'click',
        message: `Failed to add Ui properties appId=${payload?.appId} and propertyName=${payload?.propertyName}`,
        status: `Failed to Ui property`,
        action: `Clicked to add ui properties data`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(err);
        Modal.error({
          title: err?.response?.data?err?.response?.data?.message:err?.response?.response,
          icon: <CheckCircleFilled />,
          okText:t("impaqx.adminApp.close"),
          //cancelText: 'Cancel',
          onOk() {
          },
        });
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-properties?appId=${payload?.appId}&query=&sortfield=undefined&sortorder=undefined&useMongo=false`,
          config
        );
        //`${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-proerties?appId=${appId}&query=${queryString}&sortfield=${sortField}&sortorder=${sortorder}`,
        if (response.status === 200) {
          yield put(uiPropertiesJson(response.data));
        }
      yield put(showAppMessage(err?.response));
    }
  });
}
export function* editUiPropertiesData() {
  yield takeEvery(EDIT_APP_UI_PROPERTY, function* ({ payload }) {
    const { propId, updatedData } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-properties/${propId}`,
        updatedData,
        config
      );
      if (res.status === 200) {
        const traceObj ={
					type: `edit_ui_properties_data`,
					event: 'click',
					message: `Ui properties data edited for id=${propId} and appId=${updatedData?.appId}`,
					status: `Ui properties data edited  successfully `,
					action: `Clicked edit ui properties data`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-properties?appId=${updatedData?.appId}&query=&sortfield=undefined&sortorder=undefined&useMongo=false`,
          config
        );
        //`${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-proerties?appId=${appId}&query=${queryString}&sortfield=${sortField}&sortorder=${sortorder}`,
        if (response.status === 200) {
          yield put(uiPropertiesJson(response.data));
        }
        Modal.success({
          title: t("impaqx.adminApp.propertySaveMessage"),
          icon: <ExclamationCircleOutlined />,
          okText: "Close",
        });
      }
    } catch (err) {
      const traceObj ={
        type: `edit_ui_properties_data`,
        event: 'click',
        message: `Failed to edit Ui properties data for id=${propId} and appId=${updatedData?.appId}`,
        status: `Failed to edit Ui properties data `,
        action: `Clicked edit ui properties data`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(err);
      const response = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-properties?appId=${updatedData?.appId}&query=&sortfield=undefined&sortorder=undefined&useMongo=false`,
        config
      );
      //`${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-proerties?appId=${appId}&query=${queryString}&sortfield=${sortField}&sortorder=${sortorder}`,
      if (response.status === 200) {
        yield put(uiPropertiesJson(response.data));
      }
      Modal.error({
        title: err.response,
        icon: <ExclamationCircleOutlined />,
        okText: "Close",
      });
      yield put(showAppMessage(err?.response));
    }
  });
}
export function* deleteUiPropertiesData() {
  yield takeEvery(DELETE_APP_UI_PROPERTY, function* ({ payload }) {
    const { id, appId,propId } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const res = yield axios.delete(
        `${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-properties/${propId}`,
        config
      );
      if (res.status === 200) {
        const traceObj ={
					type: `delete_ui_properties_data`,
					event: 'click',
					message: `Ui properties data deleted for id=${propId} and appId=${appId}`,
					status: `Ui properties data deleted successfully `,
					action: `Clicked delete ui properties data`,
					referer_action_id: localStorage.getItem("referer_action_id"),
					trackId: uuidv4(),
					user_session: sessionStorage.getItem("user_session")
				  };
				  localStorage.setItem("referer_action_id",traceObj.trackId);
				  trace({"traceObj":traceObj});
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-properties?appId=${appId}&query=&sortfield=undefined&sortorder=undefined&useMongo=false`,
          config
        );
        //`${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-proerties?appId=${appId}&query=${queryString}&sortfield=${sortField}&sortorder=${sortorder}`,
        if (response.status === 200) {
          yield put(uiPropertiesJson(response.data));
        }
        Modal.success({
          title: t("impaqx.adminApp.uiPropertyDeleteMessage"),
          icon: <ExclamationCircleOutlined />,
          okText: "Close",
        });
      }
    } catch (err) {
      const traceObj ={
        type: `delete_ui_properties_data`,
        event: 'click',
        message: `Failed to delete Ui properties data for Id=${propId} and appId=${appId}`,
        status: `Failed to delete Ui properties data `,
        action: `Clicked to delete ui properties data`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(err);
      yield put(showAppMessage(err?.response));
    }
  });
}

export function* getAccountUserAppInstanceRoles() {
  yield takeEvery(GET_ACCOUNT_USER_APP_INSTANCE_ROLES, function* ({ requestData }) {
    try {
      const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountUser-appInstanceRole?accountUserId=${localStorage.getItem("accountUserId")}`,
        config
      );
      if (res.status === 200) {
        // const traceObj ={
				// 	type: `get_account_user_app_instance_roles`,
				// 	event: 'click',
				// 	message: `${res?.data?.totalElements} results found`,
				// 	status: `Account User AppInstance Roles Retrieve successfully `,
				// 	action: `Clicked account user appinstance roles `,
				// 	referer_action_id: localStorage.getItem("referer_action_id"),
				// 	trackId: uuidv4(),
				// 	user_session: sessionStorage.getItem("user_session")
				//   };
				//   localStorage.setItem("referer_action_id",traceObj.trackId);
				//   trace({"traceObj":traceObj});
        yield put(accountUserAppInstanceRoles(res.data));
      }
    } catch (error) {
      // const traceObj ={
      //   type: `get_account_user_app_instance_roles`,
      //   event: 'click',
      //   message: `0 results found`,
      //   status: `Failed To Retrieve Account User AppInstance Roles`,
      //   action: `Clicked account user appinstance roles `,
      //   referer_action_id: localStorage.getItem("referer_action_id"),
      //   trackId: uuidv4(),
      //   user_session: sessionStorage.getItem("user_session")
      //   };
      //   localStorage.setItem("referer_action_id",traceObj.trackId);
      //   trace({"traceObj":traceObj});
      console.log(error);
      yield put(showAppMessage(error?.response));
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getApps),
    fork(appRegister),
    fork(deleteApp),
    fork(publishApp),
    fork(editApp),
    fork(getPublishedApps),
    fork(subscribeApp),
    fork(getSubscribedApps),
    fork(getMenuApps),
    fork(getDeveloperApp),
    fork(getMfaSetupHome),
    fork(appLoginAuthentication),
    fork(onUsing2fa),
    fork(getUsing2faValue),
    fork(addAppPermission),
    fork(addAppRole),
    fork(getAppPermissions),
    fork(getAppRoles),
    fork(deleteAppPermission),
    fork(updateAppPermission),
    fork(deleteAppRole),
    fork(updateAppRole),
    fork(getAppRolePermissions),
    fork(addAppSettingsReactJson),
    fork(getApplicationSettingsDetails),
    fork(getAppInstance),
    fork(getUiProperties),
    fork(addAUiPropertiesData),
    fork(editUiPropertiesData),
    fork(deleteUiPropertiesData),
    fork(getAdminAppUiPropertiesDetails),
    fork(subscribeAppDetailPage),
    fork(subscribeAppSettingsPage),
    fork(getAccountUserAppInstanceRoles)
  ]);
}
